import { useQuery } from "@tanstack/react-query";
import type { DeviceTokenApi } from "./device-token-api";

export interface UseHasActivePushDeviceOptions {
  deviceTokenApi: DeviceTokenApi;
  /** When true the query runs. Typically gated on the push feature flag. */
  enabled?: boolean;
}

export const ACTIVE_PUSH_DEVICE_QUERY_KEY = ["push-active-device"];

/**
 * Whether any of the calling user's devices can receive push right now — for
 * a client that has no device token of its own to check (web). `data` stays
 * `undefined` while loading or after an error, so callers can tell "unknown"
 * apart from a definite "no device".
 */
export function useHasActivePushDevice({ deviceTokenApi, enabled = true }: UseHasActivePushDeviceOptions) {
  return useQuery({
    queryKey: ACTIVE_PUSH_DEVICE_QUERY_KEY,
    queryFn: () => deviceTokenApi.hasActiveDevice(),
    enabled,
    refetchOnWindowFocus: true,
    retry: 1,
  });
}
